import { useState } from 'react';
import { getValidationErrorMessages } from './utils';

export const useCustomLink = ({
  closeDialog,
  onSaveCustomLink,
  title = '',
  url = '',
}) => {
  const [customLink, setCustomLink] = useState({ title, url });
  const [validationErrorMessages, setValidationErrorMessages] = useState({});

  const clearValidationErrorMessage = (field) => {
    setValidationErrorMessages((prevState) => ({ ...prevState, [field]: '' }));
  };

  const updateCustomLink = (linkUpdate) => {
    setCustomLink((prevState) => ({ ...prevState, ...linkUpdate }));
  };

  const handleSaveLinkOnClick = () => {
    const errorMessages = getValidationErrorMessages(
      customLink.title,
      customLink.url,
    );

    if (errorMessages) {
      setValidationErrorMessages(errorMessages);
      return false;
    }

    onSaveCustomLink(customLink);
    closeDialog();
  };

  const hasValidationErrors = Object.values(validationErrorMessages).some(
    Boolean,
  );

  const hasLinkChanged = title !== customLink.title || url !== customLink.url;

  const isSaveButtonDisabled = !hasLinkChanged || hasValidationErrors;

  return {
    clearValidationErrorMessage,
    customLink,
    handleSaveLinkOnClick,
    isSaveButtonDisabled,
    updateCustomLink,
    validationErrorMessages,
  };
};
